<template lang="pug">
	div
		.sfc-breadcrumbs(itemscope itemtype="http://schema.org/BreadcrumbList")
			span.breadcrumb-element(v-for="(element, index) of breadcrumbsList" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem")
				a(:href="element.href || element.url || null" itemprop="item")
					span(itemprop="name")
						| {{element.name}}
				meta(itemprop="position" :content="index + 1")
				span.arrow(v-if="index != (breadcrumbsList.length - 1)")
					| &nbsp;→&nbsp;
</template>

<style lang="stylus" scoped>
@import '~assets/css/redesign-v1/variables.styl'
.sfc-breadcrumbs
	width: 100%
	margin: 0 auto
	overflow: hidden
	text-overflow: ellipsis
	text-align: center
	line-height: body-font-line-heigth-sm
	> span
		display: inline-block
		> a
			font-family: main-font
			color: gray-70 !important
			font-size: body-font-size-sm
			text-decoration: underline
		&:last-child
			a
				text-decoration: none
				cursor: default
		.arrow
			font-size: body-font-size-sm
			color: gray-70
			margin: 0 6.8px 0 3.9px
			&:last-of-type
				margin: 0 6.2px 0 3.9px

</style>

<script>
	export default {
		props:[
			'breadcrumbsList'
		]
	}
</script>
